import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import docIcon from "../../../../assets/img/svg/docIcon.svg"
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import PropTypes from 'prop-types';
import $ from "jquery"
import { geteditsocdocinfo, filedeletesoc } from "../../../../actions/SOCAction";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import styles from "../../../../assets/jss/customStyle";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import moment from "moment";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import del from "../../../../assets/img/svg/Del.svg"

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    inputfieldAlign: {
        "& fieldset": {
            top: "-1px !important",
        }

    },
}));

const CheckboxWithBlackCheck = withStyles({
    root: {
        "& .MuiSvgIcon-root": {
            fill: "#FFFFFF",
            width: 20,
            height: 20,
            border: "1px solid #000000",
            "&:hover": {
                backgroundColor: "#FFFFFF"
            }
        },
        "&$checked": {
            "& .MuiIconButton-label": {
                position: "relative",
                zIndex: 0,
                backgroundColor: "#FFFFFF",
            },
            "& .MuiIconButton-label:after": {
                content: '""',
                height: 10,
                width: 10,
                position: "absolute",
                backgroundColor: "#000000",
                zIndex: -1
            }
        }
    },
    checked: {}
})(Checkbox);

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

// const EditSOC_Detail = () => {
//     const classes = useStyles();
//     const theme = useTheme();
//     const [personName, setPersonName] = React.useState([]);
//     const [radio, setRadio] = React.useState('sample');
//     const [isError, setError] = React.useState(false);
//     const inputFile = useRef(null);
//     const [isMobile, setisMobile] = React.useState();

//     useEffect(() => {
//         setInterval(() => {
//             resize()
//         }, 100);

//     }, []);
//     const resize = () => {
//         if (window.innerWidth < 850) { setisMobile(true) }
//         else { setisMobile(false) }
//     };
//     const [state, setState] = React.useState({
//         checkedA: true,
//         checkedB: false
//     });

//     const handleChangeCheckbox = name => event => {
//         setState({ ...state, [name]: event.target.checked });
//     };

//     const AttachFiles = (e) => {
//         inputFile.current.click();
//     };

//     useEffect(() => {

//     }, []);

//     const handleChange = (event) => {
//         setPersonName(event.target.value);
//     };

//     const handleRadio = (event) => {
//         setRadio(event.target.value);
//     };
class EditSOC_Detail extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            value: 0,
            isError: false,
            isMobile: false,
            Docs: {},
            check: false,
            filename: "",
            awsname: "",
            DelIndex: 0,
            addData: {
                Id: 0,
                ProjectId: 0,
                Date: '',
                DocumentName: "",
                Comments: '',
                DocumentId: 0,
            }
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.DocumentId = parseInt(localStorage.getItem("SOCEditId"))
        this.state.addData.Id = parseInt(localStorage.getItem("SOCEditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.geteditsocdocinfo(this.state.addData.Id, this.state.addData.ProjectId)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Statement1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Statement").addClass("d-none");
        $("#Statement").removeClass("d-block");
        $("#SOCL").removeClass("active-color");
        $("#SOCT").removeClass("fw-bolder");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    }
    AttachFiles = (e) => {
        this.inputFile.current.click();
    };
    UploadFile = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            this.state.Docs = upload
            this.setState({})
        })
        this.props.dispatch({ type: "SHARE_SOCFILES", data: this.state.Docs })
    };
    setCheckbox = () => {

        this.state.Docs.check = !this.state.Docs.check;
        this.setState({});

    };
    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    handleInputChange = (e, str) => {
        this.state.addData[str] = e.target.value;
        this.setState({})
        this.props.dispatch({ type: "SHARE_SOCDATAS", data: this.state.addData })

    }
    geteditsocdocinfo = (id, pid) => {
        let apiUrl = API.STATEMENTOFCOMPLETION + '/' + pid + '?documentId=' + id
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SOCEDIT_DOCS", data: response.data });
                    this.props.dispatch({ type: "SHARE_SOCFILES", data: this.state.Docs });
                    this.props.dispatch({ type: "SHARE_SOCDATAS", data: this.state.addData });
                    this.state.addData.DocumentName = response.data.DocumentName;
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Date = response.data.Date;
                    if (response.data?.Attachments != undefined) {
                        this.state.Docs = {
                            FileName: response.data.Attachments.FileName,
                            ObjectKey: response.data.Attachments.ObjectKey,
                            AwsFolderName: response.data.Attachments.AwsFolderName,
                            AwsUniqueFileName: response.data.Attachments.AwsUniqueFileName,
                            FileExtention: response.data.Attachments.FileExtention,
                            FileUrl: response.data.Attachments.FileUrl,
                            FileSize: response.data.Attachments.FileSize,
                            check: false,
                        }
                        this.setState({})
                    }
                    let Error = {
                        "DateError": false,
                    }
                    this.state.Error = Error;
                    this.setState({})
                    this.props.dispatch({ type: "ERROR_SOCDATAS", data: this.state.Error })
                    this.props.dispatch({ type: "SHARE_SOCDATAS", data: this.state.addData })
                    this.props.dispatch({ type: "SHARE_SOCFILES", data: this.state.Docs })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }
    DeleteItem = () => {
        let tempData = {};
        if (this.state.DelIndex == 0) {
            if (this.state.Docs.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeletesoc(this.state.addData.Id, this.state.awsname))
            }
        }
        this.state.Docs = {};
        this.setState({})
        this.props.dispatch({ type: "SHARE_SOCFILES", data: this.state.Docs })
        window.$("#deletepopup").modal("hide");
        this.geteditsocdocinfo(this.state.addData.Id)
    }

    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                <div style={{ margin: this.state.isMobile ? "0" : "15px 30px" }}>
                    <div className="row px-3 mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label><label style={{ whiteSpace: 'nowrap' }}>Documents  :</label></label>
                        </div>
                        <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                            {/* <label>{this.state.addData.DocumentName}</label> */}
                            <label> {this.state.addData.DocumentId == 1 ? "Completion Letter as per anexure VII" : "GMB Completion Certificate"}</label>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label>Date :</label>
                        </div>
                        <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                            {this.props.errorsocpass.DateError ?
                                <TextField
                                    type="date"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    error
                                    value={moment(this.state.addData.Date).format("YYYY-MM-DD")}
                                    onChange={(e) => { this.handleInputChange(e, "Date") }}

                                    helperText="Required field must be filled in"
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                    classes={{ root: classes.helperText }}
                                />
                                :
                                <TextField
                                    type="date"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={moment(this.state.addData.Date).format("YYYY-MM-DD")}
                                    onChange={(e) => { this.handleInputChange(e, "Date") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            }
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label><label style={{ whiteSpace: 'nowrap' }}>Attachments  :</label></label>
                        </div>
                        <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                            <TextField
                                disabled
                                variant="outlined"
                                size="small"
                                placeholder="Browse File"
                                fullWidth
                                accept=".pdf"
                                onChange={(e) => this.UploadFile(e)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment className="mr-0">
                                            <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                <AttachFileIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    className: `border-radius ${classes.inputfieldAlign}`
                                }}
                            />
                            <input
                                hidden
                                accept=".pdf"
                                type="file"
                                ref={this.inputFile}
                                onChange={(e) => this.UploadFile(e)}
                            />
                            {this.state.Docs.FileName == undefined ? <></> :
                                <div className="row pt-3">
                                    <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1">
                                        <label class="contCheck">
                                            <input type="checkbox" checked={this.state.Docs.check} onChange={() => this.setCheckbox()} ></input>
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1">
                                        <img src={docIcon} />
                                    </div>
                                    <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9 pl-4" >
                                        <label className="fw-700">{this.state.Docs.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(this.state.Docs.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                    </div>
                                    {this.state.Docs.check == true ?
                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1 pt-2 pl-0 pr-0 mr-0 space">
                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(this.state.Docs.FileName, this.state.Docs.AwsUniqueFileName, this.state.Docs.Id) }} />
                                        </div> : <></>}
                                </div>
                            }
                        </div>
                        <div className="row mr-0 pr-0">
                            <div className="col-12 mt-3 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label>Comments :</label>
                            </div>
                            <div className="col-12 mt-3 col-sm-12 pb-4 col-md-12 col-lg-10 col-xl-10 mr-0 pr-0">
                                <TextField
                                    multiline
                                    rows={8}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={this.state.addData.Comments}
                                    onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" onClick={() => { window.$("#deletepopup").modal("hide") }} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        geteditsoc: state.SOCReducer.geteditsoc || [],
        errorsocpass: state.SOCReducer.errorsocpass || [],
        sharedsocfile: state.SOCReducer.sharedsocfile || [],
        sharedsocdata: state.SOCReducer.sharedsocdata || [],
    };
}

EditSOC_Detail.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditSOC_Detail))
);
